<!--
 * @Description: 
 * @Date: 2020-07-15 14:06:35
 * @LastEditTime: 2020-12-29 18:31:20
--> 
<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <!-- <el-breadcrumb-item v-for="(item, index) in levelList" :key="index">
            <span v-if="item.redirect === 'noRedirect' || index === levelList.length - 1 " class="no-redirect">{{item.meta.title}}</span>
            <a  v-else @click.prevent="handleLink(item)">{{item.meta.title}}</a>
      </el-breadcrumb-item>-->
      <el-breadcrumb-item v-for="(item, index) in breadsList" :key="index">
        <span v-if="index === breadsList.length -1 || index === 0">{{item}}</span>
        <a v-else @click="back(index)">{{item}}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from "path-to-regexp";
export default {
  data() {
    return {
      levelList: null,
      breadsList: [],
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    // 面包屑跳转
    back(val) {
      let backNum = this.breadsList.length - val - 1;
      // 面包屑大于2级 第一个不跳 最后一个不跳
      if (backNum !== 0 && this.breadsList.length > 2 && val !== 0) {
        this.$router.go(-backNum);
      }
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );

      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
      
      // 赋初始值 面包屑 在router写死
      // 最后一位拼接 项目名称 or App名称
      let { name } = this.$route.query;
      let _copy = this.$route.meta.breads.concat([]);
      let _last = _copy[_copy.length - 1];

      if (name) {
        // _copy[_copy.length - 1] = _last + " ( " + name + " ) ";
        _copy[_copy.length - 1] = _last;
        this.breadsList = _copy;
      } else {
        this.breadsList = this.$route.meta.breads;
      }
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.complile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      // 路由设置back:true  点击面包屑返回上一级
      if (item.meta.back && item.meta.back) {
        this.$router.go(-1);
        return false;
      }

      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
  },
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  // margin-left: 20px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>